/* istanbul ignore file */
import React, { useCallback, useMemo } from 'react';
import { Message } from 'botframework-directlinejs';
import * as AdaptiveCards from 'adaptivecards';
import { mergeClasses } from '@fluentui/react-components';
import { AdaptiveCardRenderer, ADAPTIVE_CARDS_DEFAULT_STYLE_OPTIONS } from './AdaptiveCardRenderer';
import AdaptiveCardBuilder from './BotFrameworkAdaptiveCardBuilder';

interface IOAuthCardProps {
  activity: Message;
  className?: string;
  disabled?: boolean;
}

export function BotFrameworkOAuthCard({ activity, className, disabled }: IOAuthCardProps) {
  const onExecuteAction = useCallback((action: any) => {
    if (disabled) {
      return;
    }
    const popup = window.open() as Window;
    const url = action.data.cardAction.value;
    popup.location.href = url;
  }, [disabled]);

  const attachment: any = activity.attachments?.find((aitem) => aitem.contentType === 'application/vnd.microsoft.card.oauth');
  const { content } = attachment;

  const direction = document.dir as 'ltr' | 'rtl' | 'auto';
  const card = useMemo(() => {
    const builder = new AdaptiveCardBuilder(AdaptiveCards, ADAPTIVE_CARDS_DEFAULT_STYLE_OPTIONS, direction);

    builder.addCommonHeaders(content);
    builder.addButtons((content.buttons), true);

    return builder.card;
  }, [content, direction]);
  card.hostConfig = new AdaptiveCards.HostConfig({});

  card.onExecuteAction = (action: any) => {
    if (onExecuteAction) {
      onExecuteAction(action);
    }
  };

  const onMount = useCallback((root: HTMLDivElement) => {
    const btn = root.querySelector('button') as HTMLButtonElement;
    btn.disabled = !!disabled;
  }, [disabled]);

  return (
    <AdaptiveCardRenderer
      card={card}
      className={mergeClasses(className, disabled ? 'disabled' : '', 'oauth-card')}
      onMount={onMount}
    />
  );
}

BotFrameworkOAuthCard.defaultProps = {
  className: undefined,
  disabled: false,
};
